import * as yup from 'yup';

// this is the value the rich text editor gets if a user types something
// then removes everything.
export const emptyQuillContent = '<p><br></p>';

export const updateValidationSchema = yup.object().shape({
  content: yup
    .string()
    .required('Did you forget to write a story?')
    .notOneOf(['<p><br></p>', '<p><br/></p>', '<p><br /></p>'], 'Did you forget to write a story?'),
  structuredContent: yup.object().shape({ ops: yup.array() }).required('Did you forget to write a story?'),
});
